import { isBrowser } from 'ws-scripts/modules/environment';
import logger from 'ws-scripts/modules/logger';
import { isValidPostalCode } from './locationUtils';
import { getCookie } from './cookies';
import { getDDCUrlParams, getDDCUserLocation } from './ddcHelper';

const LOG_PREFIX = '[ws-locations-data][defaultPostalCode]';
const POSTAL_CODE_SOURCES = [
	{ label: 'URL geoZip', get: () => getDDCUrlParams().geoZip },
	{ label: 'cookie', get: () => getCookie('DDC.postalCode') },
	{ label: 'userLocation', get: () => getDDCUserLocation()?.userPostalCode }
];

/**
 * Returns the best available postal code in priority order:
 * 1. URL param  — DDC.getUrlParams().geoZip
 * 2. Cookie     — DDC.postalCode
 * 3. User       — DDC.userLocation.userPostalCode
 * 4. Default    — defaultPostalCode
 *
 * Returns null when not running in a browser.
 */
export const getDefaultPostalCode = ({ defaultPostalCode } = {}) => {
	if (!isBrowser) {
		logger.info(`${LOG_PREFIX} Not in browser, skipping`);
		return null;
	}

	const match = POSTAL_CODE_SOURCES.find((source) => {
		const value = source.get()?.trim();
		return value && isValidPostalCode(value);
	});

	if (match) {
		const value = match.get()?.trim();
		logger.info(
			`${LOG_PREFIX} Using postal code from ${match.label}: ${value}`
		);
		return value;
	}

	logger.info(
		`${LOG_PREFIX} No valid postal code found from any source, using default: ${defaultPostalCode}`
	);
	return defaultPostalCode?.trim();
};
